// extracted by mini-css-extract-plugin
export default {"menu-view__title":"w_b5 my-2 p-2","menu-view__tile-row":"w_b6 d-flex"};